import React from 'react';

import Tippy from '@tippyjs/react';

import { ia } from 'lib/helpers/utility';
import { useUIContext } from 'lib/context/UIContext/UIContext';
import { useTagContext } from 'lib/context/TagContext/TagContext';

import TagPill from '../../TagPill/TagPill';

const OrderedView = ({ handleRemove = () => {}, showAllTags }) => {
  const { device } = useUIContext();
  const { importantTags, regularTags } = useTagContext() || {};

  const getOtherTags = () => {
    if (device !== 'desktop') return regularTags;
    if (!ia(importantTags)) return regularTags?.slice(showAllTags);
    if (importantTags.length === 1) return regularTags?.slice(showAllTags - importantTags.length);
    return regularTags;
  };
  const otherTags = getOtherTags();

  const renderTag = (tag) => <TagPill tag={tag} className="max-h-[25px]" onRemove={handleRemove} />;

  return (
    <div className="flex flex-col gap-3">
      {importantTags?.slice(showAllTags).length > 0 && (
        <div className="flex flex-col gap-1">
          <p className="text-sm text-neutral-800">Important tags</p>
          <div className="flex flex-col gap-2">
            {importantTags.slice(showAllTags).map((tag, index) =>
              tag?.name?.length > 40 ? (
                <Tippy
                  appendTo={document.body}
                  content={tag?.name}
                  className="tippy-dark text-base"
                  maxWidth="none"
                  key={tag?.id ?? index}>
                  <div>{renderTag(tag)}</div>
                </Tippy>
              ) : (
                <React.Fragment key={tag?.id ?? index}>{renderTag(tag)}</React.Fragment>
              )
            )}
          </div>
        </div>
      )}

      {ia(otherTags) && (
        <div className="flex flex-col gap-1">
          <p className="text-sm text-neutral-800">
            {ia(importantTags) ? 'All other tags on this chart' : 'All tags on this chart'}
          </p>
          <div className="flex flex-col gap-2">
            {otherTags?.map((tag, index) =>
              tag?.name?.length > 40 ? (
                <Tippy
                  content={tag?.name}
                  className="tippy-dark text-base"
                  key={tag?.id ?? index}
                  maxWidth="none">
                  <div>{renderTag(tag)}</div>
                </Tippy>
              ) : (
                <React.Fragment key={tag?.id ?? index}>{renderTag(tag)}</React.Fragment>
              )
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default OrderedView;
